export default {
  adobe: true,
  brightcove: true,
  dropbox: true,
  castoriginal: true,
  castfull: true,
  facebook2: true,
  flag: true,
  flageuro: true,
  flagus: true,
  flagar: true,
  flagaus: true,
  flagbr: true,
  flagch: true,
  flagcs: true,
  flagcz: true,
  flagde: true,
  flagdu: true,
  flages: true,
  flagfr: true,
  flagko: true,
  flagnl: true,
  flagpt: true,
  flaggen: true,
  flagit: true,
  flagja: true,
  flagjp: true,
  flagkr: true,
  flagpl: true,
  flagru: true,
  flagtr: true,
  flagsg: true,
  flaguk: true,
  flaguae: true,
  flagzh: true,
  google: true,
  googledrive: true,
  microsoftcolor: true,
  kazam: true,
  linkedin2: true,
  robot: true,
  shootstacolour: true,
  shutterstock: true,
  twitter2: true,
  wistia: true,
  youtube: true,
  videoproject: true,
  webinarproject: true,
  podcastproject: true,
  animationproject: true,
  proeditcolor: true,
  fuseoriginal: true,
  elevateoriginal: true,
  cueoriginal: true,
  prooriginal: true,
  castcolor: true,
  elevatecolor: true,
  procolor: true
};